import React from "react";
import "./custom2.css";

//Preventing right-click > save Image (I know they can just do printScreen, but that is in low res)
//document.addEventListener('contextmenu', event => event.preventDefault());

function Custom2() {
    return(
        <a className="customContainer" href="/custom3">
            <div className="liliesBorder">
                <img src="./images/liliesBorder.jpg" className="liliesBorderImage" alt="Decoration" />
            </div>
            <div className="slideContainer" id="slide2">
                <div className="stepContainer">
                    <span className="stepBox"></span>
                    <span className="stepText">
                        Sending Photos
                    </span>
                    <span className="arrowFloat">
                        <img className="rightArrow" src="./images/misc/arrowright2.gif" alt="cue to click for next slide."></img>
                    </span>
                </div>
            </div>
            <div className="instructions">
                <div className="instructionText">
                    Send several photos that you like and I will give a price range on each one. The quote will contain an explanation of what details will be included for the low, medium and high end of the price range.
                </div>
                <img className="instructionImage" src="./images/commission/submittedPhotos.jpg" alt="examples of photos submitted for quote."></img>
            </div>
        </a>
    );
};


export default Custom2